//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import entries from '~/config/changelog'

export default {
    layout: 'default',
    middleware: [],

    data(){ return {
        entries,

        examples: [
            { id: 'x4Xt3P7FQ2M', url: '//www.youtube.com/watch?v=x4Xt3P7FQ2M' },
            { id: 'MwhN-EagofM', url: '//www.youtube.com/watch?v=MwhN-EagofM' },
            { id: 'ka991cn0H5M', url: '//www.youtube.com/watch?v=ka991cn0H5M' },
            { id: 'taGMVdgxxrw', url: '//www.youtube.com/watch?v=taGMVdgxxrw' },
            { id: 'taGMVdgxxrw', url: '//www.youtube.com/watch?v=taGMVdgxxrw' },
            { id: 'q8KkjaW8PDc', url: '//www.youtube.com/watch?v=q8KkjaW8PDc' },
            { id: '7cg6oKOeSdw', url: '//www.youtube.com/watch?v=7cg6oKOeSdw' },
            { id: 'C35OJ81vv9g', url: '//www.youtube.com/watch?v=C35OJ81vv9g' },

        ]
    }},

    mounted(){
        // console.log(this)
    }
}
